/*
 * Developed by HuMingZhi on 12/29/18 5:43 PM
 * Copyright (c) 2018. All right reserved.
 */
import { log } from './log';
/**
 * @param {Function} fn 支持第一个参数作为key缓存结果
 * @return {Function} 返回函数缓存计算结果
 */
export var cacheWrap = function (fn) {
    var cachedMap = Object.create(null);
    return function (str) {
        if (!str) {
            log('warning', 'missing function param', 'utils', 'cacheWrap.js', 'cacheWrap');
        }
        var guardedStr = str || 'unknown';
        var result = cachedMap[guardedStr];
        if (result) {
            return result;
        }
        cachedMap[guardedStr] = fn(guardedStr);
        return cachedMap[guardedStr];
    };
};
